module.exports = __webpack_public_path__ + "img/nothing.0e7fd7b4.png";